import BasicContentRichText from './BasicContentRichText';

export { type BasicContentRichTextProps } from './BasicContentRichText';
export default BasicContentRichText;
